import { styled } from '@linaria/react';

import { uiToken } from '~/shared/constants/uiToken';

export const Root = styled.label`
  display: block;
  cursor: pointer;
`;

export const HiddenInput = styled.input`
  position: absolute;
  overflow: hidden;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  clip: rect(0, 0, 0, 0);
  border: 0;
`;

export const Switcher = styled.div`
  -webkit-tap-highlight-color: transparent;
  width: 62px;
  height: 32px;
  position: relative;
  box-sizing: border-box;
  background-color: #191919;
  border-radius: 16px;
  box-shadow: inset 0 0 0 1px rgb(255 255 255 / 10%);
  cursor: pointer;
  transition-duration: 0.2s;
  transition-property: background-color, box-shadow;
  transition-timing-function: linear;

  ${HiddenInput}:checked ~ & {
    background-color: ${uiToken.color.button.default};
    box-shadow: none;
  }

  ${HiddenInput}:focus-visible ~ & {
    outline: 2px solid ${uiToken.color.border.glassActive};
    outline-offset: 2px;
  }

  &::before {
    width: 28px;
    height: 28px;
    position: absolute;
    top: 2px;
    left: 2px;
    content: '';
    background-color: #323232;
    border-radius: 50%;
    box-shadow:
      inset 0 0 0 1px rgb(255 255 255 / 10%),
      0 0 2px 0 #000;
    transition:
      transform 0.2s ease-in-out,
      background-color 0.2s ease-in-out;

    ${HiddenInput}:checked ~ & {
      transform: translateX(30px);
      background-color: #e5e5e5;
    }
  }
`;
